<template>
  <el-form-item prop="unit" class="mt-0 mb-0 flex items-center justify-center">
    <el-select v-model="model.unit" @change="$emit('change', model.unit)" class="unit-select">
      <el-option
        v-for="item in unitOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script src="./player-setup-videowall-unit.js"></script>
<style lang="scss" src="./player-setup-videowall-unit.scss"></style>
